import { FETCH_WANQUALITY } from 'actions/wanquality';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_WANQUALITY:
			return action.payload;
		default:
			return state;
	}
};